<div mat-dialog>
  <h2 mat-dialog-title>
    {{ config.title || "NCAL Notification" }}
  </h2>
  <div mat-dialog-content>
    <div class="text-wrapper">
      <p>{{ config.data.message }}</p>
    </div>
  </div>
  <div mat-dialog-actions class="actions">
    <button class="cancel-btn" mat-raised-button (click)="onClose()">
      CANCEL
    </button>
    <button class="submit-btn" mat-raised-button (click)="onClose()">OK</button>
  </div>
</div>
